import React from 'react';
import CapitalNeedDataGrid from '../CapitalNeedDataGrid/CapitalNeedDataGrid';
import type { Filter } from '#/common/components/DataGrid';

interface CapitalNeedsProps {
  omitColumns?: string[];
  hideNewAction?: boolean;
  permanentFilters?: Filter[];
}

const CapitalNeeds: React.FC<CapitalNeedsProps> = ({
  omitColumns,
  hideNewAction,
  permanentFilters,
}) => {
  return (
    <CapitalNeedDataGrid
      omitColumns={omitColumns}
      hideNewAction={hideNewAction}
      permanentFilters={permanentFilters}
    />
  );
};

export default React.memo(CapitalNeeds);
